import { render, staticRenderFns } from "./reply_mail.vue?vue&type=template&id=48e0eceb"
import script from "./reply_mail.vue?vue&type=script&lang=js"
export * from "./reply_mail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports